<template>
    <div class="mx_content">
        <div class="mx_title">
            <div class="title_left">
                <span>人员资质</span>
            </div>
            <div class="title_right">
                <el-button v-if="canEdit && baseModule === 'zljysq'" size="mini" @click="ryzzAdd">添加</el-button>
                <el-button size="mini" @click="ryzzExport">导出</el-button>
            </div>
        </div>
        <el-table :data="listData" style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="index" label="序号" width="50" align="center" />
            <el-table-column prop="fullName" label="文件夹" align="center">
            </el-table-column>
            <el-table-column prop="ryzzName" label="名称" align="center">
            </el-table-column>
            <!-- <el-table-column prop="ryzzOwner" label="姓名" align="center" width="120px">
                <template slot-scope="scope">
                    <div>{{ scope.row.ryzzOwner }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="manageDept" label="保管部门" align="center">
                <template slot-scope="scope">
                    <div v-if="canEdit">
                        <el-input v-model="scope.row.manageDept" v-can-edit :can-edit="canEdit" name="manageDept" placeholder="请输入保管部门" />
                    </div>
                    <div v-else>{{ scope.row.manageDept }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="managePeople" label="保管人" align="center">
                <template slot-scope="scope">
                    <div v-if="canEdit">
                        <el-input v-model="scope.row.managePeople" v-can-edit :can-edit="canEdit" name="managePeople" placeholder="请输入保管人" />
                    </div>
                    <div v-else>{{ scope.row.managePeople }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="effectiveDate" label="有效日期" align="center" width="180px">
                <template slot-scope="scope">
                     <div v-if="scope.row.effectiveDate">{{ $moment(scope.row.effectiveDate).format('YYYY-MM-DD') }}</div>
                    <div v-else>-</div>
                </template>
            </el-table-column>
            <el-table-column prop="borrowType" label="借用类型" align="center" width="180px">
                <template slot-scope="scope">
                    <div v-if="canEdit">
                        <div v-if="baseModule === 'zljysq'">
                            <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" :rules="feeDescRules" name="借用类型">
                                <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                    <el-select v-model="scope.row.borrowType" placeholder="请选择">
                                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </el-tooltip>
                            </ValidationProvider>
                        </div>
                        <div v-else>{{ borrowTypeFormatter(scope.row.borrowType) }}</div>
                    </div>
                    <div v-else>{{ borrowTypeFormatter(scope.row.borrowType) }}</div>
                </template>
            </el-table-column> -->
            <el-table-column v-if="canEdit && baseModule === 'zljysq'" label="操作" align="center" width="70px">
                <template slot-scope="scope">
                    <el-link type="primary" @click="delClick(scope.row)">删除</el-link>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
const { uuid } = require('@/global/utils/index.js')
import moment from 'moment'
export default {
    components: {},
    props: {
        // 通用属性
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 1 },
        baseModule: { type: String, default: null },
        module: { type: String, default: null },
        baseUrl: { type: String, default: null },
        listName: { type: String, default: null },
        isHttp: { type: Boolean, default: true }

        // 自定义属性
    },
    setup() {
        const feeTypeRules = {
            required: true
        }
        const feeDescRules = {
            required: true
        }
        const occureDateRules = {
            required: true
        }

        const feeAmountRules = {
            required: true
        }

        const handleFeeAmountInput = (value) => {
            // 这里可以添加对费用金额的其他校验逻辑
        }

        // 如果需要，可以在这里添加对ValidationProvider实例的引用逻辑
        // 例如：
        // const { validate } = useValidation();
        // ...

        return {
            feeTypeRules,
            feeAmountRules,
            handleFeeAmountInput,
            feeDescRules,
            occureDateRules
            // ... 其他响应式引用
        }
    },
    data() {
        return {
            moduleInfo: {},
            loginUser: this.$store.getters.loginUser,
            listData: [],
            wfInstance: {},
            options: [
                {
                    value: 1,
                    label: '电子版'
                },
                {
                    value: 2,
                    label: '纸质版'
                }
            ]
        }
    },
    computed: {},
    watch: {
        listData: {
            handler(newVal, oldVal) {
                // 当listData发生变化时，更新vo.passenger[listName]
                this.vo.passenger[this.listName] = newVal
            },
            deep: true
        }
    },
    created() {
        this.$bus.on('wfInstance', this.getWfInstance)
    },
    beforeDestroy() {
        this.$bus.off('wfInstance', this.getWfInstance)
    },
    mounted() {
        this.moduleInfo = {
            delUrl: '/' + this.baseUrl + '/' + this.module + '/delete',
            addNewUrl: '/' + this.baseUrl + '/' + this.module + '/addNew',
            insertUrl: '/' + this.baseUrl + '/' + this.module + '/insert',
            moduleCode: this.module,
            updateUrl: '/' + this.baseUrl + '/' + this.module + '/update',
            listDataUrl: '/' + this.baseUrl + '/' + this.module + '/listdata',
            getByIdUrl: '/' + this.baseUrl + '/' + this.module + '/getById',
            querydata: '/' + this.baseUrl + '/' + this.module + '/querydata'
        }
        this.getListData()
    },
    updated() {},
    methods: {
        borrowTypeFormatter(val) {
            var str = ''
            switch (val) {
                case 1:
                    str = '电子版'
                    break
                case 2:
                    str = '纸质版'
                    break
            }
            return str
        },
        async getListData(model) {
            if (this.isHttp) {
                const data = {
                    pageNum: 1,
                    pageSize: 999,
                    urlsearch: `formId:${this.vo.id}`
                }
                const res = await this.$app.listdata(this.moduleInfo.listDataUrl, data)
                if (res.code === 'success') {
                    this.listData = res.body.listdata
                }
            } else if (this.listName) {
                if (this.vo.passenger && this.vo.passenger[this.listName] && this.vo.passenger[this.listName].length > 0) {
                    this.vo.passenger[this.listName].forEach((item) => {
                        if (!item.formId) {
                            item.formId = this.vo.id
                        }
                        if (!item.id) {
                            item.id = uuid()
                        }
                        if (!item.creatorId) {
                            item.creatorId = this.loginUser.id
                        }
                        if (!item.createTime) {
                            // 获取当前时间
                            const now = moment()
                            // 格式化当前时间
                            const formattedNow = now.format('YYYY-MM-DD HH:mm:ss')
                            item.createTime = formattedNow
                        }
                    })
                    this.listData = this.vo.passenger[this.listName]
                }
            } else {
                console.log('请传递listName参数或改用接口获取数据')
            }
        },
        // 删除当前行
        delClick(row) {
            // 找到要删除的项的索引
            const index = this.listData.findIndex((item) => item.id === row.id)
            if (index !== -1) {
                // 使用splice方法删除该项
                this.listData.splice(index, 1)
            } else {
                console.error('未找到要删除的数据项')
            }
        },
        getWfInstance(val) {
            this.wfInstance = val
        },
        ryzzAdd() {
            // console.log(this.wfInstance)
            // if (this.wfInstance.id) {
            //     const el = {
            //         attrs: {
            //             listviewurl: 'disk.vwfilefolder.list?urlsearch=',
            //             'dialog-title': '选择人员资质',
            //             'exclude-fields': '',
            //             multiple: true
            //         }
            //     }
            //     const vnode = { context: this, data: { model: { expression: '' } } }
            //     console.log(el, vnode)
            //     this.$bus.emit('openListpageDialog', el, null, vnode)
            // } else {
            //     this.$parent.$vnode.context.btnSubmitClick('AutoSave', (saveRst, a, b, c) => {
            //         if (saveRst) {
            //             const el = {
            //                 attrs: {
            //                     listviewurl: 'disk.vwfilefolder.list?urlsearch=',
            //                     'dialog-title': '选择人员资质',
            //                     'exclude-fields': '',
            //                     multiple: true
            //                 }
            //             }
            //             const vnode = { context: this, data: { model: { expression: '' } } }
            //             this.$bus.emit('openListpageDialog', el, null, vnode)
            //         }
            //     })
            // }
            const el = {
                attrs: {
                    listviewurl: 'disk.vwfilefolder.list?urlsearch=',
                    'dialog-title': '选择人员资质',
                    'exclude-fields': '',
                    multiple: true
                }
            }
            const vnode = { context: this, data: { model: { expression: '' } } }
            console.log(el, vnode)
            this.$bus.emit('openListpageDialog', el, null, vnode)
        },
        ryzzExport() {
            if (this.listData.length === 0) {
                this.$alert('暂无数据导出', '提示', {
                    confirmButtonText: '确定'
                })
                return
            } else {
                window.open(`/apigw/tbgl/zljysqRyzzItem/exportCustomData?formId=${this.vo.id}`)
            }
        },
        // 通用列表选择对话框-选择数据后回调
        onSelectListpageRowCompleted(selectedRows, attr) {
            console.log('🚀 ~ onSelectListpageRowCompleted ~ selectedRows:', selectedRows)
            let arr = []
            let arrItem = {}
            selectedRows.forEach((item) => {
                arrItem = {
                    fullName: item.fullName,
                    ryzzName: item.name,
                    // manageDept: item.mrgDeptName,
                    // managePeople: item.mrgStaffName,
                    ryzzId: item.id
                }
                arr.push(arrItem)
            })
            this.listData = arr
        },
        download(attach) {
            console.log(attach)
            if (attach.id === undefined) return
            window.open(process.env.VUE_APP_BASE_API + '/tbgl/zljysq/downloadById?inline=false&attachIds=' + attach.passenger.attachments[0].id)
        }
    }
}
</script>

<style scoped lang="scss">
/deep/ .el-table .el-link--inner {
    width: 100%;
}
.mx_content /deep/ .el-table__body-wrapper tr td:last-child {
    border-right-color: #e2e7ed !important;
}
.mx_content {
    .mx_title {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #999;
        justify-content: space-between;
        background: #ffffff;
        padding: 0 10px;
    }
}

.attachment-link-wrapper {
    display: flex;
    align-items: center;
    /* 如果需要垂直居中 */
    justify-content: space-between;
    /* 确保链接和按钮之间有间隔，并分别位于开始和结束位置 */
    .el-lint-inner {
        width: 100%;
    }
}

.attachment-link {
    flex: 1;
    /* 占据可用空间，但不会挤压删除按钮 */
    overflow: hidden;
    /* 隐藏超出容器的部分 */
    text-overflow: ellipsis;
    /* 显示省略号 */
    white-space: nowrap;
    /* 防止文本换行 */
    /* 其他你需要的样式 */
}

.remove-button {
    /* 确保按钮始终可见，并位于行尾 */
    /* 你可以添加更多的样式来美化按钮 */
}
</style>
